(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2gether-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tg-na]').forEach(function (root) {
    var track = root.querySelector('[data-tg-na-track]');
    var prev = root.querySelector('[data-tg-na-prev]');
    var next = root.querySelector('[data-tg-na-next]');
    if (!track) { if (prev) prev.disabled = true; if (next) next.disabled = true; return; }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    function step() {
      var card = track.querySelector('.tg-na-card');
      return card ? card.getBoundingClientRect().width + 16 : 320;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // drag to scroll (mouse)
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startLeft = track.scrollLeft; track.classList.add('is-dragging'); });
    window.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - startX; if (Math.abs(dx) > 4) moved = true; track.scrollLeft = startLeft - dx; });
    window.addEventListener('mouseup', function () { if (!down) return; down = false; track.classList.remove('is-dragging'); });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const HI = (window.tgI18n && window.tgI18n.header) || {};
  const header = document.querySelector('tg-header');
  if (!header) return;

  const burger = header.querySelector('[data-tg-burger]');
  const takeover = header.querySelector('[data-tg-takeover]');
  // NOTE: do NOT early-return if the burger menu is missing — the cart
  // drawer and the add-to-cart interceptor live in this same IIFE and must
  // always run. The menu listeners are guarded individually below instead.

  const closers = header.querySelectorAll('[data-tg-takeover-close]');

  let lastFocus = null;
  let hideTimer = null;

  function open() {
    lastFocus = document.activeElement;
    // A close() may have queued `hidden = true` — cancel it or the menu
    // would vanish mid-open when reopened within the fade-out window.
    clearTimeout(hideTimer);
    takeover.hidden = false;
    // Force a reflow so the fade-in transition fires, then set state
    // SYNCHRONOUSLY. (This used to happen inside requestAnimationFrame,
    // which made toggle() read stale state on quick taps — the burger
    // needed multiple presses and could strand the menu invisible.)
    void takeover.offsetWidth;
    takeover.setAttribute('data-open', 'true');
    takeover.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    burger.setAttribute('aria-label', (HI.close_menu || "Затвори менюто"));
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    // Focus the close button for keyboard nav
    const close = takeover.querySelector('.tg-takeover-close');
    if (close) close.focus({ preventScroll: true });
  }

  function close() {
    takeover.removeAttribute('data-open');
    takeover.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-label', (HI.open_menu || "Отвори менюто"));
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      // Re-check the real open state — not the burger's aria attribute —
      // so a reopen during the fade-out never gets display:none'd away.
      if (takeover.getAttribute('data-open') !== 'true') {
        takeover.hidden = true;
      }
    }, 320);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
  }

  function toggle() {
    if (takeover.getAttribute('data-open') === 'true') close();
    else open();
  }

  // Only wire the burger menu if its elements exist — cart code below runs regardless.
  if (burger && takeover) {
    burger.addEventListener('click', toggle);
    closers.forEach((el) => el.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && takeover.getAttribute('data-open') === 'true') {
        close();
      }
    });

    // Backdrop click-to-close: .tg-takeover-inner fully covers the backdrop,
    // so its own [data-tg-takeover-close] listener can never receive a click.
    // Treat clicks on the empty chrome (inner padding / grid gaps) as "outside".
    takeover.addEventListener('click', (e) => {
      const t = e.target;
      if (
        t === takeover ||
        (t.classList &&
          (t.classList.contains('tg-takeover-inner') ||
            t.classList.contains('tg-takeover-grid') ||
            t.classList.contains('tg-takeover-backdrop')))
      ) {
        close();
      }
    });

    // Close after a tile click — gives the page transition time to start
    takeover.querySelectorAll('.tg-takeover-tile').forEach((tile) => {
      tile.addEventListener('click', () => {
        // Don't await — let the link navigate naturally
        setTimeout(close, 0);
      });
    });
  }

  // ── Cart drawer ─────────────────────────────────────────────────
  const cartDrawer = header.querySelector('[data-tg-cart-drawer]');
  const cartOpenBtn = header.querySelector('[data-tg-cart-open]');
  const cartClosers = header.querySelectorAll('[data-tg-cart-close]');
  const cartBody = cartDrawer ? cartDrawer.querySelector('[data-tg-cart-body]') : null;
  const cartFoot = cartDrawer ? cartDrawer.querySelector('[data-tg-cart-foot]') : null;
  const cartCountBadge = header.querySelector('[data-tg-cart-count]');
  const cartDrawerCount = cartDrawer ? cartDrawer.querySelector('[data-tg-cart-drawer-count]') : null;
  const cartSubtotal = cartDrawer ? cartDrawer.querySelector('[data-tg-cart-subtotal]') : null;
  const cartRoot = window.Shopify?.routes?.root || '/';
  const cartCurrency = (cartDrawer && cartDrawer.getAttribute('data-currency')) || 'EUR';
  const collectionsUrl = (cartDrawer && cartDrawer.getAttribute('data-collections-url')) || '/collections';

  function moneyFormat(cents) {
    try {
      return new Intl.NumberFormat((HI.locale || 'bg'), { style: 'currency', currency: cartCurrency }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2) + ' ' + cartCurrency;
    }
  }

  function pluralize(n, one, many) {
    return n === 1 ? one : many;
  }

  function updateCartCounts(itemCount) {
    if (cartCountBadge) {
      cartCountBadge.textContent = itemCount;
      if (itemCount > 0) cartCountBadge.removeAttribute('hidden');
      else cartCountBadge.setAttribute('hidden', '');
    }
    if (cartDrawerCount) cartDrawerCount.textContent = itemCount;
    const countLine = cartDrawer ? cartDrawer.querySelector('.tg-cart-drawer-count') : null;
    if (countLine) {
      const n = itemCount;
      countLine.innerHTML = '<span data-tg-cart-drawer-count>' + n + '</span> ' + pluralize(n, (HI.items_word_one || "артикул"), (HI.items_word_other || "артикула"));
    }
  }

  function renderCart(cart) {
    if (!cartBody) return;
    // Guard against error payloads ({status, message, description}) being
    // rendered as if they were a cart.
    if (!cart || typeof cart.item_count !== 'number') return;
    updateCartCounts(cart.item_count || 0);

    if (!cart.items || cart.items.length === 0) {
      cartBody.innerHTML =
        '<div class="tg-cart-drawer-empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4">' +
            '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/>' +
            '<path d="M16 10a4 4 0 0 1-8 0"/>' +
          '</svg>' +
          '<p>' + (HI.cart_empty || "Количката е празна") + '</p>' +
          '<a href="' + collectionsUrl + '">' + (HI.to_shop || "Към магазина") + '</a>' +
        '</div>';
      if (cartFoot) cartFoot.hidden = true;
      document.dispatchEvent(new CustomEvent('tg:cart-rendered', { detail: cart }));
      return;
    }

    if (cartFoot) cartFoot.hidden = false;
    if (cartSubtotal) cartSubtotal.textContent = moneyFormat(cart.total_price);

    const html = cart.items.map((item) => {
      const img = item.image
        ? '<img class="tg-cart-item-img" src="' + item.image + '" alt="" loading="lazy">'
        : '<div class="tg-cart-item-img"></div>';
      const variant =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<span class="tg-cart-item-variant">' + escapeHtml(item.variant_title) + '</span>'
          : '';
      return (
        '<div class="tg-cart-item" data-tg-cart-key="' + item.key + '">' +
          img +
          '<div class="tg-cart-item-info">' +
            '<a class="tg-cart-item-title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<div class="tg-cart-item-controls">' +
              '<div class="tg-cart-item-qty">' +
                '<button type="button" data-tg-qty-dec aria-label="' + (HI.qty_decrease || "Намали количеството") + '">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-tg-qty-inc aria-label="' + (HI.qty_increase || "Увеличи количеството") + '">+</button>' +
              '</div>' +
              '<button type="button" class="tg-cart-item-remove" data-tg-remove>' + (HI.remove || "Премахни") + '</button>' +
            '</div>' +
          '</div>' +
          '<span class="tg-cart-item-price">' + moneyFormat(item.final_line_price) + '</span>' +
        '</div>'
      );
    }).join('');
    cartBody.innerHTML = html;
    document.dispatchEvent(new CustomEvent('tg:cart-rendered', { detail: cart }));
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[c]);
  }

  function fetchCart() {
    return fetch(cartRoot + 'cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => { renderCart(cart); return cart; })
      .catch(() => {});
  }

  function changeQty(key, qty) {
    if (!cartBody) return;
    cartBody.style.opacity = '0.5';
    fetch(cartRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
      .then(({ ok, data }) => {
        if (ok && data && data.items) {
          renderCart(data);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        } else {
          // 422 (e.g. qty above stock) returns an error body, not a cart —
          // re-fetch the real cart so the drawer keeps showing true state.
          fetchCart();
        }
        cartBody.style.opacity = '';
      })
      .catch(() => { fetchCart(); cartBody.style.opacity = ''; });
  }

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    void cartDrawer.offsetWidth;
    cartDrawer.setAttribute('data-open', 'true');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    fetchCart();
    const closeBtn = cartDrawer.querySelector('.tg-cart-drawer-close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.removeAttribute('data-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    setTimeout(() => {
      if (!cartDrawer.hasAttribute('data-open')) cartDrawer.hidden = true;
    }, 280);
    if (cartOpenBtn) cartOpenBtn.focus({ preventScroll: true });
  }

  if (cartOpenBtn) {
    cartOpenBtn.addEventListener('click', (e) => {
      // The trigger is a real link to the cart page; JS upgrades it to the drawer.
      e.preventDefault();
      openCart();
    });
  }
  cartClosers.forEach((el) => el.addEventListener('click', closeCart));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.getAttribute('data-open') === 'true') closeCart();
  });

  // Focus trap — both overlays declare aria-modal, so Tab must not escape
  // into the page behind them. One shared handler covers whichever is open.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    let dialog = null;
    if (cartDrawer && cartDrawer.getAttribute('data-open') === 'true') dialog = cartDrawer;
    else if (takeover && takeover.getAttribute('data-open') === 'true') dialog = takeover;
    if (!dialog) return;
    const focusables = Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      (el) => el.offsetParent !== null
    );
    if (focusables.length === 0) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;
    if (e.shiftKey) {
      if (active === first || !dialog.contains(active)) {
        e.preventDefault();
        last.focus();
      }
    } else if (active === last || !dialog.contains(active)) {
      e.preventDefault();
      first.focus();
    }
  });

  // Delegate qty + remove inside the drawer
  if (cartBody) {
    cartBody.addEventListener('click', (e) => {
      const row = e.target.closest('[data-tg-cart-key]');
      if (!row) return;
      const key = row.getAttribute('data-tg-cart-key');
      const qtyEl = row.querySelector('.tg-cart-item-qty span');
      const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;

      if (e.target.closest('[data-tg-qty-inc]')) changeQty(key, currentQty + 1);
      else if (e.target.closest('[data-tg-qty-dec]')) changeQty(key, Math.max(0, currentQty - 1));
      else if (e.target.closest('[data-tg-remove]')) changeQty(key, 0);
    });
  }

  // Cart count badge refresh + opt-in events
  function refreshCart() { fetchCart(); }
  document.addEventListener('cart:refresh', refreshCart);
  // Any script can open the drawer after adding to cart by dispatching this.
  document.addEventListener('cart:open', openCart);
  document.addEventListener('cart:updated', (e) => {
    if (e.detail) updateCartCounts(e.detail.item_count);
    else fetchCart();
  });

  // Intercept Add to Cart forms — AJAX add and auto-open the drawer.
  // (The custom product page handles its own form and dispatches cart:open,
  // so we only catch generic forms flagged with data-tg-ajax here.)
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    const isProductForm = form.hasAttribute('data-tg-ajax');
    if (!isProductForm) return;
    e.preventDefault();
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    const fd = new FormData(form);
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: fd,
    })
      .then((r) => r.json())
      .then(() => fetchCart())
      .then(() => { openCart(); })
      .catch(() => {})
      .finally(() => { if (submitBtn) submitBtn.disabled = false; });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
